import { Link, useSearchParams } from 'react-router';
import { ARTIFACT_TYPE_LABELS, CHARACTER_REGION_LABELS, pageTitle } from '@thottbot/shared';
import { useSearch } from '../api/client';
import { ArtifactTable } from '../components/ArtifactTable';

export function Search() {
  const [params] = useSearchParams();
  const q = params.get('q') ?? '';
  const result = useSearch(q);
  return (
    <div className="page">
      <title>{pageTitle(q || null, 'Search')}</title>
      <h1>Search: {q}</h1>
      {q.trim().length < 2 && <p className="muted">Type at least two characters.</p>}
      {result.isPending && q.trim().length >= 2 && <p className="muted">Searching...</p>}
      {result.isError && <p className="error">Search failed. Try again.</p>}
      {result.data && result.data.groups.length === 0 && (result.data.characters ?? []).length === 0 && (
        <p>
          No results for <b>{q}</b>. Know something about it? <a href="/submit">Submit it</a>.
        </p>
      )}
      {result.data?.groups.map((g) => (
        <section key={g.type} className="section" data-testid={`group-${g.type}`}>
          <h2>
            {ARTIFACT_TYPE_LABELS[g.type].plural} <span className="muted">({g.total})</span>
          </h2>
          <ArtifactTable items={g.items} />
        </section>
      ))}
      {result.data && (result.data.characters ?? []).length > 0 && (
        <section className="section" data-testid="group-character">
          <h2>Characters</h2>
          <ul>
            {result.data.characters.map((c) => (
              <li key={c.id}>
                <Link to={c.url}>{c.name}</Link>{' '}
                <span className="muted">
                  · {c.level} {c.race} {c.class} · {c.realmName} ({CHARACTER_REGION_LABELS[c.region]})
                </span>
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
}
